export default __webpack_public_path__ + "static/media/40202.09ebb629.jpg";